'use client'

import { useEffect, useRef } from 'react'

interface ContentBlockVideoProps {
	src: string
	className?: string
}

export default function ContentBlockVideo({ src, className }: ContentBlockVideoProps) {
	const videoRef = useRef<HTMLVideoElement>(null)

	useEffect(() => {
		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
		if (!prefersReducedMotion) {
			videoRef.current?.play()
		}
	}, [])

	return (
		<video ref={videoRef} className={className} loop playsInline muted controls>
			<source src={src} />
		</video>
	)
}
